import axios from 'axios'

const api = axios.create({
    baseURL: 'https://reginafidei.pmkpay.com',
    // timeout: 5000,
    headers: {
        'Authorization': `Basic YXBpcG1rOjQxMWQzZmU0ODU0NDhiOGU5MTBmYzJhYTYwYzc0ZjEw`,
        'Content-Type': 'application/json'
    }
})

export default api;